import { Navigate } from 'react-router-dom';

import { HowToPlay } from '@sorare/core/src/components/HowToPlay';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

const footballCards = [
  'joshua-kimmich-2025-limited-455',
  'lamine-yamal-nasraoui-ebana-2025-limited-620',
  'ousmane-dembele-2025-limited-545',
  'desire-doue-2025-limited-563',
  'moises-isaac-caicedo-corozo-2025-limited-692',
];

const HowToPlayPage = () => {
  const {
    flags: { showHowToPlay = false },
  } = useFeatureFlags();

  if (!showHowToPlay) {
    return <Navigate to="/blog/football/get-started-with-our-beginner-guide" />;
  }

  return <HowToPlay cards={footballCards} />;
};

export default HowToPlayPage;
